import { createContext, useContext, useState } from "react";

const ThemeContext = createContext()

export function ThemeProvider({children}) {
    const [products, setProducts] = useState(null)

    return (
        <ThemeContext.Provider value={{
            products,
            setProducts
        }}>{children}
        </ThemeContext.Provider>
    )
}

export const useThemeCotext = function(){
    return useContext(ThemeContext)
}